// BaseInviteService.js

/**
 * BaseInviteService.js
 *
 * Service for base invite lifecycle actions via Cloud Functions.
 */

import { functions, httpsCallable } from 'firebaseConfig';
import { buildTenantCallableFields } from 'utilities/basePersistence';

const callable = (name) => httpsCallable(functions, name);

export async function createBaseInvites({ baseKey, invites = [], role = 'member', message = '' }) {
  if (!baseKey || !Array.isArray(invites) || invites.length === 0) {
    throw new Error('baseKey and at least one invite are required');
  }

  const fn = callable('createBaseInvites');
  const { data } = await fn({ ...buildTenantCallableFields(baseKey), invites, role, message });
  return data || null;
}

export async function revokeBaseInvite({ baseKey, inviteKey }) {
  if (!baseKey || !inviteKey) {
    throw new Error('baseKey and inviteKey are required');
  }

  const fn = callable('revokeBaseInvite');
  const { data } = await fn({ ...buildTenantCallableFields(baseKey), inviteKey });
  return data || null;
}

export async function listBaseInvites({ baseKey }) {
  if (!baseKey) {
    throw new Error('baseKey is required');
  }

  const fn = callable('listBaseInvites');
  const { data } = await fn({ ...buildTenantCallableFields(baseKey) });
  return Array.isArray(data?.invites) ? data.invites : [];
}

export async function acceptBaseInvite({ token }) {
  if (!token) {
    throw new Error('token is required');
  }

  const fn = callable('acceptBaseInvite');
  const { data } = await fn({ token });
  return data || null;
}
